import { useBackend } from "../../services";

export const useUpdateMercadoPagoPayments = () => {
  const { post } = useBackend();
  return async () => post("admin/updateMercadoPagoPayments", {});
};
